import { sortArrayByKey } from '@/utils/helpers/array-helper'
import { userGenders } from '@/utils/helpers/user-helper'
import { storeTypes } from '@/utils/helpers/store-helper'

export const fileTypes = {
  image: 'image',
  video: 'video',
  audio: 'audio',
  document: 'document',
  proof: 'proof',
  logo: 'logo'
}

export const fileVariants = {
  thumbnail: 'thumbnail',
  original: 'original'
}

export const defaultImages = {
  defaultProductImage: '/img/default/default_product_image.png',
  defaultStoreLogo: '/img/default/default_store_logo.svg',
  defaultBrandLogo: '/img/default/default_brand_logo.svg',
  defaultStoreCoverImage: '/img/default/default_cover_store.jpg',
  defaultBrandCoverImage: '/img/default/default_cover_brand.jpg',
  defaultImageAvatarM: '/img/account/profile/default_avatar.png',
  defaultImageAvatarF: '/img/account/profile/default_avatar_female.png',
  defaultImageCategoryIcon: '/img/default/default_category_icon.jpg',
  defaultImageBanner: '/img/default/banner/default_landscape_image.jpg',
  defaultImageBannerFlashsale:
    '/img/home/flashsale/banner_flashsale_default.png',
  defaultImageShowcase: '/img/default/default-showcase.jpg',
  defaultImageReview: '/img/default/default_review_product.svg',
  defaultImageCreditDebit: '/img/default/default_credit_debit_rectangle.svg'
}

export const defaultUploadImageAccept = ['.jpg', '.jpeg', '.png', '.webp']
export const uploadImageExtensionErrorMessage = 'File tidak sesuai, harap masukan file .jpg, .jpeg, .png, atau .webp!'

export const getFileExtension = (file = {}) => {
  const fileName = file.name || (file.raw && file.raw.name) || ''
  const lastDotIndex = fileName.lastIndexOf('.')

  if (lastDotIndex === -1) {
    return ''
  }

  return fileName.slice(lastDotIndex).toLowerCase()
}

export const isAllowedUploadImageExtension = (file = {}) => {
  return defaultUploadImageAccept.includes(getFileExtension(file))
}

export const getDefaultImageFromFiles = (
  files = [],
  name = null,
  variant = null,
  webp = false
) => {
  if (files.length <= 0) {
    return ''
  }

  files = sortArrayByKey(
    files.filter(file => file.type === fileTypes.image),
    'sequence'
  )

  if (name) {
    files = files.filter(file => file.name === name)
  }

  if (variant) {
    const variantFiles = files.filter(file => file.variant === variant)
    if (variantFiles.length > 0) {
      files = variantFiles
    }
  }

  if (files.length <= 0) {
    return ''
  }

  return webp ? files[0].value + '.webp' : files[0].value
}

export const getDefaultImgOnError = (
  event,
  defaultImage = defaultImages.defaultProductImage
) => {
  if (event.target.src && event.target.src.includes('.webp')) {
    event.target.src = event.target.src.replace('.webp', '')
  } else {
    event.target.src = defaultImage
  }
}

export const getDefaultImgProductOnError = (event) => {
  getDefaultImgOnError(event, defaultImages.defaultProductImage)
}

export const getDefaultImgBannerOnError = (event, isFlashsale = false) => {
  getDefaultImgOnError(
    event,
    isFlashsale
      ? defaultImages.defaultImageBannerFlashsale
      : defaultImages.defaultImageBanner
  )
}

export const getDefaultCategoryIconOnError = (event) => {
  getDefaultImgOnError(event, defaultImages.defaultImageCategoryIcon)
}

export const getDefaultUserAvatarOnError = (
  event,
  gender = userGenders.female
) => {
  getDefaultImgOnError(
    event,
    gender === userGenders.male
      ? defaultImages.defaultImageAvatarM
      : defaultImages.defaultImageAvatarF
  )
}

export const getDefaultStoreLogo = (
  event,
  type = storeTypes.storePartner.value
) => {
  getDefaultStoreLogoOnError(event, type)
}

export const getDefaultStoreLogoOnError = (
  event,
  storeType = storeTypes.storePartner.value
) => {
  getDefaultImgOnError(
    event,
    storeType === storeTypes.storePartner.value
      ? defaultImages.defaultStoreLogo
      : defaultImages.defaultBrandLogo
  )
}

export const getDefaultShowcaseImageOnError = (event) => {
  getDefaultImgOnError(event, defaultImages.defaultImageShowcase)
}

export const checkFileExists = (url) => {
  // Make sure this function is accessed on the client side.
  return new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve(true)
    img.onerror = () => resolve(false)
    img.src = url
  })
}

export const filterOnlyExistingFiles = async (images, urlKeyName = 'value') => {
  const results = await Promise.all(
    images.map(async (img) => {
      const exists = await checkFileExists(img[urlKeyName])
      return exists ? img : null
    })
  )

  return results.filter(img => img !== null)
}

export const getDefaultReviewImageOnError = (event) => {
  getDefaultImgOnError(event, defaultImages.defaultImageReview)
}

export const getDefaultCreditDebitImageOnError = (event) => {
  getDefaultImgOnError(event, defaultImages.defaultImageCreditDebit)
}

export const fileToBase64 = (file) => {
  const reader = new FileReader()

  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file)
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = function (error) {
      reject(error)
    }
  })
}

export const base64ToFile = (dataurl, filename) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}
